import React from "react";
import NavBar from "./NavBar";

import Logo from "../../../resources/img/header-menu-desplegable.png";
import { BurguerStyle } from "./headerStyle";

const Burger = ({ visible, open, handleOpen }) => {

  // const menuRef = useRef(null);
  // useOutsideClick(menuRef, () => {
  //   if (open) {
  //     handleOpen();
  //   }
  // });

  return (
    <>
      <BurguerStyle
        className="cursorPointer"
        style={{ zIndex: 0 }}
        open={open}
        onClick={() => handleOpen()}
        title="Menú lateral"
        aria-label="Menú lateral"
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            handleOpen()
          }
        }}
        tabIndex={0}
      >
        {visible ? (
          <>
            <img
              style={{ width: "100%", marginLeft: "10px" }}
              alt="Junta de Extremadura"
              src={Logo}
            />
          </>
        ) : null}
      </BurguerStyle>
      <NavBar open={open} handleOpen={handleOpen}/>
    </>
  );
};

export default Burger;
